import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

const initialState = {
  sharefile: {
    authToken: ""
  }
};

const slice = createSlice({
  name: "sharefile",
  initialState,
  reducers: {
    getAuthToken(state, action) {
      const authToken = action.payload;
      
      state.authToken = authToken;
    },
    downloadFile(state, action) {
      const response = action.payload;
      
      return response.DownloadUrl;
    }
  }
});

export const reducer = slice.reducer;

export const getAuthToken = () => async dispatch => {
  const response = await axios.get("/api/sharefile");

  dispatch(slice.actions.getAuthToken(response.data));
};

export const downloadFile = (productName, dirId) => async dispatch => {
  const response = await axios.get(`/api/sharefile/downloadUrl?dirId=${dirId}&productName=${productName}`);

  return response.data.DownloadUrl;
}

export default slice;
